module.exports = __webpack_public_path__ + "img/icon-box-active.27ad4206.svg";